import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import AICourseCreator from './pages/AICoursecreator';
import CourseDetail from './pages/CourseDetail';
import MarketingGenerator from './pages/MarketingGenerator';
import CourseTemplates from './pages/CourseTemplates';
import Admin from './pages/Admin';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Contact from './pages/Contact';
import Help from './pages/Help';
import BrandSettings from './pages/BrandSettings';
import EmailTemplates from './pages/EmailTemplates';
import Integrations from './pages/Integrations';
import SocialCalendar from './pages/SocialCalendar';
import CertificateGenerator from './pages/CertificateGenerator';
import EmailSequenceGenerator from './pages/EmailSequenceGenerator';
import VideoGenerator from './pages/VideoGenerator';
import CreationStats from './pages/CreationStats';
import ForgotPassword from './pages/ForgotPassword';
import GoogleCallback from './pages/GoogleCallback';
import Freebies from './pages/Freebies';
import DripCampaigns from './pages/DripCampaigns';
import SalesFunnels from './pages/SalesFunnels';
import AdminFreebies from './pages/AdminFreebies';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/create-course"
              element={
                <ProtectedRoute>
                  <AICourseCreator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/course/:courseId"
              element={
                <ProtectedRoute>
                  <CourseDetail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/marketing/:courseId"
              element={
                <ProtectedRoute>
                  <MarketingGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <CourseTemplates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pricing"
              element={
                <ProtectedRoute>
                  <Pricing />
                </ProtectedRoute>
              }
            />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/help" element={<Help />} />
            <Route
              path="/brand-settings"
              element={
                <ProtectedRoute>
                  <BrandSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/email-templates"
              element={
                <ProtectedRoute>
                  <EmailTemplates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/integrations"
              element={
                <ProtectedRoute>
                  <Integrations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/social-calendar/:courseId"
              element={
                <ProtectedRoute>
                  <SocialCalendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/certificates/:courseId"
              element={
                <ProtectedRoute>
                  <CertificateGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/email-sequences/:courseId"
              element={
                <ProtectedRoute>
                  <EmailSequenceGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/video-generator/:courseId"
              element={
                <ProtectedRoute>
                  <VideoGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/creation-stats"
              element={
                <ProtectedRoute>
                  <CreationStats />
                </ProtectedRoute>
              }
            />
            <Route
              path="/freebies"
              element={
                <ProtectedRoute>
                  <Freebies />
                </ProtectedRoute>
              }
            />
            <Route
              path="/drip-campaigns"
              element={
                <ProtectedRoute>
                  <DripCampaigns />
                </ProtectedRoute>
              }
            />
            <Route
              path="/sales-funnels"
              element={
                <ProtectedRoute>
                  <SalesFunnels />
                </ProtectedRoute>
              }
            />
            <Route
              path="/social-calendar"
              element={
                <ProtectedRoute>
                  <SocialCalendar />
                </ProtectedRoute>
              }
            />
            <Route
              path="/certificates"
              element={
                <ProtectedRoute>
                  <CertificateGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/email-sequence"
              element={
                <ProtectedRoute>
                  <EmailSequenceGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/video-generator"
              element={
                <ProtectedRoute>
                  <VideoGenerator />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/freebies"
              element={
                <ProtectedRoute>
                  <AdminFreebies />
                </ProtectedRoute>
              }
            />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </Router>
  );
}

export default App;
